'use client'

import Image from 'next/image'
import assistant_pic from './pics/assistant_avatar_square.jpg'

export const AssistantAvatar = () => {
    // return <AssistantWrapper imageData={assistant_pic} alt="" size="lg" fallbackInitials="W" aria-label="Walter" />

    return <Image src={assistant_pic} alt="Walter Avatar" className="rounded-xl w-10 h-10" />
}
